import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import { useForm } from "react-hook-form";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import { useDispatch, useSelector } from 'react-redux';

import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { languageOptions, stateOptions, positionalRageOptions, roles, mandalPositionalRageOptions } from '../../utils/constants';
import { debounce } from "../../utils/Debounce";
import { parse } from 'papaparse'
// import { ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import { SlButton, SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { SetCampCount, SetOpsSales, SetComponentId } from '../../redux/counterSlice'


const initials = {
  lang_id: '',
  lang_name: '',
  state_id: '',
  state_name: '',
  district_name: '',
  district_id: '',
  const_name: '',
  const_id: '',
  mandal_name: '',
  mandal_id: '',
  village_name: '',
  village_id: '',
  positional_range: '',
  price: 0,
  creative_type: ""
}



let initialValues = JSON.parse(JSON.stringify(initials));

const schema = Yup.object().shape({
  lang_id: Yup.number().required('Language is required'),
  state_id: Yup.number().optional(),
  district_id: Yup.number().optional(),
  const_id: Yup.number().optional(),
  mandal_id: Yup.number().optional(),
  village_id: Yup.number().optional(),
  positional_range: Yup.string().required('Range is required').test('', "Range is required", (text) => {
    return text !== '';
  }),
  price: Yup.number().required('Price is required').min(1, 'Must be greater than zero'),
  creative_type: Yup.string().required('Creative Type is required')
})



function PositionalPrice() {

  const dispatch = useDispatch()
  // dispatch(SetComponentId(15))

  const navigate = useNavigate();
  const [submit, setSubmit] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [constituencies, setConstituencies] = useState([]);
  const [mandals, setMandals] = useState([]);
  const [villages, setVillages] = useState([]);

  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fileLoader, setFileLoader] = useState(false);

  const [flag, setFlag] = useState('')
  const [id, setId] = useState('');
  const [search, setSearch] = useState("")

  const [view, setView] = useState(false)
  const [duplicatedata, setDuplicateData] = useState([])

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const HeaderSearch = useSelector(state => state.Head.adssearch)

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(search, event.selected)
  };
  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  const handleClose = () => {
    setShow(false);
    setView(false)
    setSubmit(false);
    setConstituencies([])
    setDistricts([])
    setMandals([])
    setVillages([])
    setStates([])
    initialValues = JSON.parse(JSON.stringify(initials));
    formik.setValues(initialValues);
  }


  // const deleteLocation = async (id1) => {
  //   try {
  //     await api({
  //       url: `/location/${id1}`,
  //       method: "DELETE",
  //       responseType: "json"
  //     });
  //     toast.success("Location Deleted Successfully");
  //     setCurrentPage(0);
  //     setSearch('');
  //     loadData(search, 0);
  //   } catch (error) {
  //     let er = error?.response?.message || "Something went wrong"
  //     Toast("error", er)
  //     if (error.response.status === 401)
  //       navigate("/")
  //   }
  // }


  const loadData = async (searchString = '', page = 0) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/location/getPrices`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString
        }
      });
      setData(res.data.data.length ? res.data.data : [])
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401)
        navigate("/")
    }
  }

  // const checkstatus = async (id, status) => {
  //   try {
  //     let res = await api({
  //       url: `/location/changeStatus`,
  //       method: "POST",
  //       responseType: "json",
  //       data: { id, status }
  //     });
  //     if (res.code === 200) {
  //       Toast('success', res.message);
  //       loadData(search, currentPage);
  //     } else {
  //       Toast('error', res?.message || 'Status update failed')
  //     }
  //   } catch (error) {
  //     let er = error?.response?.message || "Something went wrong"
  //     Toast("error", er)
  //     if (error.response.status === 401)
  //       navigate("/")
  //   }
  // }

  useEffect(() => {
    // Role check removed as it's handled by parent component
    // loadData(search, 0);
  }, []);

  const searchData = e => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0);
  }

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0);
  }

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initials)),
    validationSchema: schema,
    onSubmit: async (values) => {
      if (flag === 'add') {
        try {
          let res = await api({
            url: `/location/addLocationPrice`,
            method: "POST",
            responseType: "json",
            data: values
          });
          if (res?.code === 200) {
            Toast("success", "Location Added Successfully");
            handleClose();
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
          } else {
            Toast('error', res?.data?.message);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
      }
      if (flag === 'edit') {
        try {
          values.id = id;
          let res = await api({
            url: `/location/updateLocationPrice`,
            method: "POST",
            responseType: "json",
            data: values
          });
          if (res?.code === 200) {
            Toast("success", "Location updated Successfully");
            loadData(search, currentPage);
            handleClose()
            values = JSON.parse(JSON.stringify(initials))
          } else {
            Toast('error', res?.data?.message);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong";
          Toast('error', er);
          if (error.response.status === 401)
            navigate("/")
        }
      }
    },
  })

  const getDistricts = async (lang_id, state_id) => {
    try {
      let res = await api({
        url: `/location/getDistricts`,
        method: "POST",
        responseType: "json",
        data: { lang_id, state_id }
      });
      if (res.code === 200) {
        setDistricts(res.data);
      }
    } catch (error) {
      if (error.response.status === 401)
        navigate("/")
    }
  }

  const getMandals = async (dist_id) => {
    try {
      let res = await api({
        url: `/location/getMandalsByDistrictId`,
        method: "POST",
        responseType: "json",
        data: { dist_id }
      });
      if (res?.code === 200) {
        const newObject = { mandal_id: -1, mandal_name: "Any" }
        const updatedData = [newObject, ...res.data.mandals];
        setMandals(updatedData);
        setConstituencies([{const_id: -1, const_name: 'Any'}, ...res.data.constituencies])
      }
    } catch (error) {
      if (error.response.status === 401)
        navigate("/")
    }
  }

  const getVillages = async (mandal_id) => {
    try {
      if (mandal_id != -1) {
        let res = await api({
          url: `/location/getVillagesByMandalId`,
          method: "POST",
          responseType: "json",
          data: { mandal_id }
        });
        if (res.code === 200) {
          const newObject = { village_id: -1, village: "Any" }
          const updatedData = [newObject, ...res.data];
          setVillages(updatedData);
        }
      }
    } catch (error) {
      if (error.response.status === 401)
        navigate("/")
    }
  }

  const handleShow = async (choose, item) => {
    if (choose === "add") {
      formik.setValues(initials);
      setShow(true);
    }
    if (choose === 'edit') {
      initialValues.lang_id = item.lang_id;
      initialValues.lang_name = item.lang_name;
      item.lang_id && getStates(item.lang_id);
      initialValues.state_id = item.state_id || '';
      initialValues.state_name = item.state_name || '';
      item.state_id && await getDistricts(item.lang_id, item.state_id);
      initialValues.district_name = item.district_name || '';
      initialValues.district_id = item.dist_id || '';
      item.dist_id && await getMandals(item.dist_id)
      initialValues.mandal_name = item.mandal_name === 'Any' ? 'Any' : item.mandal_name || '';
      initialValues.mandal_id = item.mandal_id === -1 ? -1 : item.mandal_id || '';
      initialValues.const_name = item.const_name === 'Any' ? 'Any' : item.const_name || '';
      initialValues.const_id = item.const_id === -1 ? -1 : item.const_id || '';
      item.mandal_id && await getVillages(item.mandal_id)
      initialValues.village_name = item.village_name === 'Any' ? 'Any' : item.village_name || '';
      initialValues.village_id = item.village_id === -1 ? -1 : item.village_id || '';
      initialValues.positional_range = item.positional_range;
      initialValues.creative_type = item.creative_type;
      initialValues.price = item.amount;
      formik.setValues(initialValues);
      setShow(true)
    }
  };

  const fileChange = async (e) => {
    const file = e.target.files[0]
    const type = e.target.value.split(".").pop()
    if (type === 'csv') {
      setFileLoader(true)
      const reader = new FileReader();

      reader.onload = async () => {
        const jsonArray = parse(reader.result, { header: true }).data;
        try {
          let res = await api({
            url: `/location/addLocationPricewithFile`,
            method: "POST",
            responseType: "json",
            data: jsonArray
          });
          if (res.data.length > 0) {
            setView(true)
            setDuplicateData(res.data)
            Toast("success", "Locations Added Successfully with out Duplicates");
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
          }
          else if (res?.code === 200) {
            Toast("success", "Locations Added Successfully");
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
          } else {
            Toast('error', res?.message);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
        finally{
          setFileLoader(false)
        }
        setValue('file_csv', "")

      };

      reader.readAsText(file);
    } else {
      Toast("error", "Only csv files are allowed")
      setValue("file_csv", "")
    }

  }

  const getStates = (lang_id) => {
    let arr = stateOptions.filter((item) => item.lang_id === parseInt(lang_id));
    setStates(arr);
  }

  const onInputChange = (type, id) => {
    switch (type) {
      case "lang_id":
        formik.setFieldValue("lang_name", languageOptions.find(j => j.value === +id)?.label);
        formik.setFieldValue("state_id", "");
        formik.setFieldValue("state_name", "");
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue('const_name','')
        formik.setFieldValue('const_id', '')
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        formik.setFieldValue("district_id", "");
        formik.setFieldValue("district_name", "");
        break;
      case "state_id":
        formik.setFieldValue("state_name", stateOptions.find(j => j.state_id === +id)?.state_name);
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue('const_name','')
        formik.setFieldValue('const_id', '')
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        formik.setFieldValue("district_id", "");
        formik.setFieldValue("district_name", "");
        break;
      case "district_id":
        formik.setFieldValue("district_name", districts.find(j => j.dist_id === +id)?.dist_name);
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue('const_name','')
        formik.setFieldValue('const_id', '')
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        break;
      case "const_id":
        formik.setFieldValue("const_name", constituencies.find(j => j.const_id === +id)?.const_name);
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        break;
      case "mandal_id":
        formik.setFieldValue("mandal_name", mandals.find(j => j.mandal_id === +id)?.mandal_name);
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        break;
      case "village_id":
        formik.setFieldValue("village_name", villages.find(j => j.village_id === +id)?.village);
        break;
      default:
    }
  }


  return (
    <>
      <div className='flex items-center mb-3'>
        <aside className="flex items-center gap-3 ml-auto flex-wrap w-full">
        <h5 className='mr-auto'>Local Card Lists</h5>
          <div>
            <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Location">
              <SlIcon library="lucide" name="map-pin" slot="prefix"></SlIcon>

            </SlInput>
          </div>
          <div>
            {localStorage.getItem('role') === roles.financer &&
              <>
                <SlButton type="button" size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>
                  Add Location
                </SlButton>
                <label htmlFor="file" className="m-0">
                  <i className="bi bi-arrow-up-circle ml-3 px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Upload Card Lists"></i>
                  <input type="file" id="file" style={{ display: "none" }} name="file"
                    {...register("file_csv", {
                      required: false,
                      onChange: (e) => fileChange(e),
                    })}
                  />
                </label>
                {fileLoader && <div className="spinner-border text-primary" role="status"  >
            <span className="visually-hidden">Loading...</span>
          </div>}
              </>
            }
          </div>
        </aside>
      </div>


      <div className='overflow-x-auto mb-4'>
        <table className='table table-bordered'>
          <thead className="sticky top-0">
            <tr>
              <th>Language</th>
              <th>State</th>
              <th>District</th>
              <th>Constituency</th>
              <th>Mandal</th>
              <th>Village</th>
              <th>Creative Type</th>
              <th>Position</th>
              <th>Amount</th>
              <th>Created Date</th>
              {localStorage.getItem('role') === roles.financer ? <th>Actions</th> : null}
            </tr>
          </thead>
          {(data?.length && !loader) ? (
            <tbody>
              {data.map((item) => {
                return (
                  <tr key={item.id} >
                    <th>{item.lang_name}</th>
                    <td>{item.state_name || '-'}</td>
                    <td >{item.district_name || '-'}</td>
                    <td>{item.const_name || '-'}</td>
                    <td>{item.mandal_name || '-'}</td>
                    <td>{item.village_name || '-'}</td>
                    <td>{item.creative_type || '-'}</td>
                    <td>{item.positional_range}</td>
                    <td>{`₹${item.amount}`}</td>
                    <td> {formatDateWithTime(item.created_date)}</td>
                    {localStorage.getItem('role') === roles.financer ? <td>


                      <sl-tooltip content="Edit Location Details">
                        <sl-icon-button
                          library="lucide"
                          name="edit"
                          onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.id) }}></sl-icon-button>
                      </sl-tooltip>
                    </td> : null}
                  </tr>
                )
              })}
            </tbody>) : ((!data?.length && !loader)
              ? <NoDataFound colspan="8" />
              : <TableLoader colspan="8" />
          )
          }
        </table>
      </div>
      <div className='flex justify-end'>
        {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}
      </div>

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3" >
              <label className='mb-1'> Languages </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="lang_id"
                placeholder='Select Language'
                onBlur={formik.handleBlur}
                value={formik.values.lang_id}
                onChange={(e) => {
                  formik.handleChange(e); getStates(e.target.value); onInputChange('lang_id', e.target.value)
                }}
              >
                <option value="">Select Option</option>
                {
                  languageOptions.map((item) => {
                    return <option value={item.value} key={item.value} >{item.label}</option>
                  })
                }
              </select>
              {submit && formik.errors.lang_id && formik.touched.lang_id ? (<div className='text-red-600'>{formik.errors.lang_id}</div>) : null}
            </div>

            <div className="mb-3" ><label> States </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="state_id"
                placeholder='Select Language'
                onBlur={formik.handleBlur}
                value={formik.values.state_id}
                onChange={(e) => { formik.handleChange(e); getDistricts(formik.values.lang_id, e.target.value); onInputChange('state_id', e.target.value) }}
              >
                <option value="">Select Option</option>
                {
                  states.map((item) => {
                    return <option value={item.state_id} key={item.state_id} >{item.state_name}</option>
                  })
                }
              </select>
              {submit && formik.errors.state_id && formik.touched.state_id ? (<div className='text-red-600'>{formik.errors.state_id}</div>) : null}
            </div>

            <div className="mb-3" ><label> Districts </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="district_id"
                placeholder='Select Language'
                onBlur={formik.handleBlur}
                value={formik.values.district_id}
                onChange={(e) => { formik.handleChange(e); getMandals(e.target.value); onInputChange('district_id', e.target.value) }}
              >
                <option value="">Select Option</option>
                {
                  districts.map((item) => {
                    return <option value={item.dist_id} key={item.dist_id} >{item.dist_name}</option>
                  })
                }
              </select>
              {submit && formik.errors.district_id && formik.touched.district_id ? (<div className='text-red-600'>{formik.errors.district_id}</div>) : null}
            </div>

            <div className="mb-3" ><label> Constituency </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="const_id"
                placeholder='Select Constituency'
                onBlur={formik.handleBlur}
                value={formik.values.const_id}
                onChange={(e) => { formik.handleChange(e); onInputChange('const_id', e.target.value) }}
              >
                <option value="">Select Option</option>
                {
                  constituencies.map((item) => {
                    return <option value={item.const_id} key={item.const_id} >{item.const_name}</option>
                  })
                }
              </select>
              {submit && formik.errors.const_id && formik.touched.const_id ? (<div className='text-red-600'>{formik.errors.const_id}</div>) : null}
            </div>

            {formik.values.const_id === '' && <><div className="mb-3" ><label> Mandals </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="mandal_id"
                placeholder='Select Language'
                onBlur={formik.handleBlur}
                value={formik.values.mandal_id}
                onChange={(e) => { formik.handleChange(e); getVillages(e.target.value); onInputChange('mandal_id', e.target.value) }}
              >
                <option value="">Select Option</option>
                {
                  mandals.map((item) => {
                    return <option value={item.mandal_id} key={item.mandal_id} >{item.mandal_name}</option>
                  })
                }
              </select>
              {submit && formik.errors.mandal_id && formik.touched.mandal_id ? (<div className='text-red-600'>{formik.errors.mandal_id}</div>) : null}
            </div>

            <div className="mb-3" ><label> Villages </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="village_id"
                placeholder='Select Language'
                onBlur={formik.handleBlur}
                value={formik.values.village_id}
                onChange={(e) => { formik.handleChange(e); onInputChange('village_id', e.target.value) }}
              >
                <option value="">Select Option</option>
                {
                  villages.map((item) => {
                    return <option value={item.village_id} key={item.village_id} >{item.village}</option>
                  })
                }
              </select>
              {submit && formik.errors.village_id && formik.touched.village_id ? (<div className='text-red-600'>{formik.errors.village_id}</div>) : null}
            </div>
            </>}
            <div className="mb-3" ><label> Creative Type </label>
              <select
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.creative_type}
                name="creative_type"
                className="form-select"
                aria-label="Default select example">
                <option value="">select creative type</option>
                <option value="Full Page">Full Page</option>
                <option value="Full Page Video">Full Page Video</option>
                <option value="Promoted Story">Promoted Story</option>
              </select>
              {submit && formik.errors.creative_type && (formik.touched.creative_type) ? <div className="text-red-600">{formik.errors.creative_type}</div> : null}
            </div>
            <div className="mb-3" ><label> Position </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="positional_range"
                placeholder='Select Range'
                onBlur={formik.handleBlur}
                value={formik.values.positional_range}
                onChange={(e) => { formik.handleChange(e) }}
              >
                <option value="">Select Option</option>
                { positionalRageOptions.map((item) => {
                    return <option value={item.value} key={item.value} >{item.label}</option>
                  })
                } 
                {/* {Array.from({length: 50}).map((item, index) => {
                  return <option value={index} key={index} >{`P ${index}`}</option>
                })} */}
              </select>
              {submit && formik.errors.positional_range && formik.touched.positional_range ? (<div className='text-red-600'>{formik.errors.positional_range}</div>) : null}
            </div>

            <div className="mb-3" ><label>Amount</label>
              <input type="number" className="form-control" placeholder="Enter Amount" aria-label="" name="price"
                value={formik.values.price}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e)
                }} />
              {submit && formik.errors.price && formik.touched.price ? (<div className="text-red-600">{formik.errors.price}</div>) : null}
            </div>

            <button type="submit" className="btn btn-primary" onClick={(e) => setSubmit(true)}>Submit</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
      <SlDrawer label="Duplicate Records" open={view} onSlAfterHide={() => setView(false)} style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '50vw' }`}}>
        <div className='overflow-x-auto mb-4'>
          <table className='table-base'>
            <thead>
              <tr>
                <th>Language</th>
                <th>State</th>
                <th>District</th>
                <th>Constituency</th>
                <th>Mandal</th>
                <th>Village</th>
                <th>Creative Type</th>
                <th>Position</th>
                <th>Amount</th>
              </tr>
            </thead>
            {(duplicatedata?.length && !loader) ? (
              <tbody>
                {duplicatedata.map((item) => {
                  return (
                    <tr key={item.id} >
                      <th scope='row'>{item.language}</th>
                      <td>{item.state || '-'}</td>
                      <td>{item.district || '-'}</td>
                      <td>{item.constituency}</td>
                      <td>{item.mandal || '-'}</td>
                      <td>{item.village || '-'}</td>
                      <td>{item.creative_type || '-'}</td>
                      <td>{item.range}</td>
                      <td>{`₹${item.amount}`}</td>
                    </tr>
                  )
                })}
              </tbody>) : ((!data?.length && !loader)
                ? <NoDataFound colspan="7" />
                : <TableLoader colspan="7" />
            )
            }
          </table>
        </div>
        <SlButton slot="footer" variant="primary" onClick={() => setView(false)}>
          Close
        </SlButton>
      </SlDrawer>
    </>
  )
}

export default PositionalPrice;